//- Remunerations headers for employee details tab
export default[
    {
        text: 'Año',
        fieldType: 'computed',
        computed: ({ period_year }) => {
            return period_year
        },
        value: 'period_year',
        sortable: false,
    },
    {
        text: 'Mes',
        fieldType: 'computed',
        computed: ({ period_month }) => {
            // var moment = require('moment')
            // period_month = moment().month(period_month - 1).format('MMMM')
            switch(period_month){
                case 1: return 'Enero'
                case 2: return 'Febrero'
                case 3: return 'Marzo'
                case 4: return 'Abril'
                case 5: return 'Mayo'
                case 6: return 'Junio'
                case 7: return 'Julio'
                case 8: return 'Agosto'
                case 9: return 'Septiembre'
                case 10: return 'Octubre'
                case 11: return 'Noviembre'
                case 12: return 'Diciembre'
            }
        },
        value: 'period_month',
        sortable: false,
    },
    {
        text: 'Total Haberes',
        format: 'currency',
        fieldType: 'computed',
        computed: ({ total_haberes }) => {
            return total_haberes
        },
        value: 'total_haberes',
        sortable: false,
    },
    {
        text: 'Total Descuentos',
        format: 'currency',
        fieldType: 'computed',
        computed: ({ amount_discount_hh }) => {
            return amount_discount_hh
        },
        value: 'amount_discount_hh',
        sortable: false,
    },
    {
        text: 'Líquido',
        format: 'currency',
        fieldType: 'computed',
        computed: ({ liquid_salary }) => {
            return liquid_salary
        },
        value: 'liquid_salary',
        sortable: false,
    },
]
